import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import {darken, lighten, alpha} from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import FormLabel from '@mui/material/FormLabel';
import InputAdornment from '@mui/material/InputAdornment';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DateField } from '@mui/x-date-pickers/DateField';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { isNullOrNaN } from '../../Bs4Components/Bs4Utils';
import { Bs4PopoverModal } from '../../Bs4Components/Bs4ModalTopCenter';

import { 
  compareAsc, startOfWeek, endOfWeek, getDay, format, 
  setHours, setMinutes, setSeconds, setMilliseconds
} from "date-fns";

import Bs4GenericField from './Bs4GenericField'
import Bs4MainDispatch from '../../Bs4MainDispatch'
import * as Bs4Utils from '../../Bs4Components/Bs4Utils'
import Bs4I18N from '../../Bs4I18N';

const getUxDay = (date) => {  
  if (!date) return null;
  let d = setMilliseconds(date, 0);
  d = setSeconds(d, 0);
  d = setMinutes(d, 0);
  d = setHours(d, 0);  
  return parseInt(d.getTime() / 1000 / 60 / 20 / 24);
}

const SELECTION_STATE_OK = 'finish';

const Bs4DateRangePicker = (props) => {
  const theme = useTheme();
  const [hoveredDay, setHoveredDay] = React.useState(null);
  const [fieldDateNumber, setFielDatedNumber] = React.useState(0);

  const ref = React.useRef(null);

  React.useEffect(() => {
    if (ref.current) {
      ref.current.focus();      
      setFielDatedNumber(1);
    }
  }, [ref, setFielDatedNumber]);

  const InRangeDay = React.useCallback((props) => {      
    const {fieldnumber: fieldNumber, valueRange, hoveredday: hoveredDay, locale, ...other} = props;
    const startOfWeekDay = getDay(props.day) === getDay(startOfWeek(props.day));
    const endOfWeekDay = getDay(props.day) === getDay(endOfWeek(props.day));
    
    // console.log('...InRangeDay...', Bs4Utils.toDate(hoveredDay), Bs4Utils.toDate(props.day));
    // console.log('...InRangeDay.X.', getUxDay(hoveredDay), getUxDay(props.day), getUxDay(hoveredDay) - getUxDay(props.day));
    
    const inRange = alpha(theme.palette.primary.main, 0.4);
      
    const borderRadius = '50%';
    const borderColor = '#00000033';
    let sx = {
      borderWidth: '2px',
      borderStyle: 'dashed',
      borderColor: 'transparent',
    };
    const selected = getUxDay(props.day) === getUxDay(valueRange.od) || getUxDay(props.day) === getUxDay(valueRange.do);
    if (selected) {
      // console.log('...InRangeDay...', Bs4Utils.toDateTime(props.day), Bs4Utils.toDateTime(valueRange.od), Bs4Utils.toDateTime(valueRange.do));
      // console.log('...InRangeDay.X.', getUxDay(props.day), getUxDay(valueRange.od), getUxDay(valueRange.do));
    }
    
    if (getUxDay(valueRange.od) <= getUxDay(props.day) && getUxDay(props.day) <= getUxDay(valueRange.do)) {
      sx.backgroundColor = inRange;
      if (getUxDay(props.day) === getUxDay(valueRange.od) || startOfWeekDay) {
        sx.borderTopLeftRadius = borderRadius;
        sx.borderBottomLeftRadius = borderRadius;
      } 
      if (getUxDay(props.day) === getUxDay(valueRange.do) || endOfWeekDay) {      
        sx.borderTopRightRadius = borderRadius;
        sx.borderBottomRightRadius = borderRadius;
      }
    } else if (hoveredDay) {              
      if (fieldNumber === 1 && getUxDay(hoveredDay) <= getUxDay(props.day) && getUxDay(props.day) <= getUxDay(valueRange.do) ) {
        // sx.backgroundColor = inRange1;
        sx.borderTopColor = borderColor;
        sx.borderBottomColor = borderColor;          
        if (getUxDay(props.day) === getUxDay(hoveredDay) || startOfWeekDay) {
          sx.borderTopLeftRadius = borderRadius;
          sx.borderBottomLeftRadius = borderRadius;
          sx.borderLeftColor = borderColor;
        } 
        if (getUxDay(props.day) === getUxDay(valueRange.do) || endOfWeekDay) {
          sx.borderTopRightRadius = borderRadius;
          sx.borderBottomRightRadius = borderRadius;
          sx.borderRightColor = borderColor;
        }
      }

      if (fieldNumber === 2 && getUxDay(valueRange.od) <= getUxDay(props.day) && getUxDay(props.day) <= getUxDay(hoveredDay)) {
        sx.borderTopColor = borderColor;
        sx.borderBottomColor = borderColor;
        //sx.backgroundColor = inRange1;
        if (getUxDay(props.day) === getUxDay(valueRange.od) || startOfWeekDay) {
          sx.borderTopLeftRadius = '50%';
          sx.borderBottomLeftRadius = '50%';
          sx.borderLeftColor = borderColor;
        } 
        if (getUxDay(props.day) == getUxDay(hoveredDay) || endOfWeekDay) {
        // if (compareAsc(props.day, hoveredDay) === 0 || endOfWeekDay) {
          sx.borderTopRightRadius = '50%';
          sx.borderBottomRightRadius = '50%';
          sx.borderRightColor = borderColor;
        }
      }        
    }
    
    // pointerEvents = "none";
    return (
      <Box sx={sx}>
        <PickersDay {...other} selected={selected}/>
      </Box>
    );      
  }, []);

  const isValidDate = React.useCallback((date) => date instanceof Date && !isNullOrNaN(date), []);

  const getValue = React.useCallback(() => {
    if (fieldDateNumber === 1 && isValidDate(props.value?.od)) return props.value.od;
    if (fieldDateNumber === 2 && isValidDate(props.value?.do)) return props.value.do;
    return null;
  }, [fieldDateNumber, props.value, isValidDate]);  

  const updateOdDo = React.useCallback((value) => {            
    // console.log('...Change.oddo...', fieldDateNumber, Bs4Utils.toDateTime(value?.od), Bs4Utils.toDateTime(value?.do), value);
    if (fieldDateNumber !== 1 && fieldDateNumber !== 2) {
      // console.log('...Change.oddo.-1.0.return -1;');
      return -1;
    }
    if (!isValidDate(value?.od) && !isValidDate(value?.do)) {
      // console.log('...Change.oddo.-1.1.return -1;');
      return -1;
    }
    if (!isValidDate(value?.od)) {
      value.od = value.do;      
      props.onChange({...value});
      // console.log('...Change.oddo.2.return 2;');
      return 2;
    }
    if (!isValidDate(value?.do)) {
      value.do = value.od;
      props.onChange({...value});
      // console.log('...Change.oddo.1.return 1;');
      return 1;
    }
    if (compareAsc(value.od, value.do) > 0) {
      if (fieldDateNumber === 1) value.do = value.od;
      if (fieldDateNumber === 2) value.od = value.do;
      props.onChange({...value});
      // console.log('...Change.oddo.fn.return fieldDateNumber;', fieldDateNumber);
      return fieldDateNumber;
    }
    props.onChange({...value});
    // console.log('...Change.oddo.0.return 0;');
    return 0;
  }, [fieldDateNumber, props, isValidDate]);

  const handleChangeOd = React.useCallback((newValue, context) => {
    // console.log('...ChangeOd...', Bs4Utils.toDateTime(newValue), context);
    props.onChange({od: newValue, do: props.value.do});
    // updateOdDo({od: newValue, do: props.value.do});
  }, [props.value, updateOdDo]);

  const handleChangeDo = React.useCallback((newValue, context) => {
    // console.log('...ChangeDo...', Bs4Utils.toDateTime(newValue), context);
    props.onChange({od: props.value.od, do: newValue});
    // updateOdDo({od: props.value.od, do: newValue});
  }, [props.value, updateOdDo]);
  
  const handleFocusOd = React.useCallback((e) => {
    // console.log('...FocusBlur..Focus..Do'); 
    updateOdDo(props.value);
    setFielDatedNumber(1);
  }, [setFielDatedNumber, updateOdDo, props.value]);

  const handleFocusDo = React.useCallback((e) => {
    // console.log('...FocusBlur..Focus..Od');
    updateOdDo(props.value);
    setFielDatedNumber(2);
  }, [setFielDatedNumber, updateOdDo, props.value]);  
  
  const handleChangeCalendar = React.useCallback((newValue, selectionState, selectedView) => {
    // console.log('...Change.Calendar..', fieldDateNumber, Bs4Utils.toDate(newValue), selectionState, selectedView);    
    if (fieldDateNumber === 1 && updateOdDo({od: newValue, do: props.value.do}) >= 0) {
      if (selectionState === SELECTION_STATE_OK) setFielDatedNumber(2);
    }
    if (fieldDateNumber === 2 && updateOdDo({od: props.value.od, do: newValue}) === 0) {
      if (selectionState === SELECTION_STATE_OK) props?.onClose();
    }
  }, [fieldDateNumber, setFielDatedNumber, props.value]);

  const handleChangeNaw = React.useCallback((event) => {
    handleChangeCalendar(new Date(), SELECTION_STATE_OK);
  }, [handleChangeCalendar]);
    
  const handleClear = (e) => {    
    props.onChange({od: null, do: null});
    setFielDatedNumber(1);
  }

  const handleClose = (e) => {    
    const oddo = updateOdDo({...props.value});
    // console.log('...Close.Close.Close...', fieldDateNumber, oddo);
    if (oddo <= 0) props?.onClose();
  }

  // console.log('...Date Range...' , props);

  const [xx, xxXX] = Bs4MainDispatch.useBs4Locale();
  
  return (                
    <LocalizationProvider 
      dateAdapter={AdapterDateFns} 
      adapterLocale={xx}
      localeText={xxXX.components.MuiLocalizationProvider.defaultProps.localeText}
    >                
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={0} sx={{padding: 1, paddingTop: 2, flexWrap: 'wrap', position: 'relative'}}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
          <DateField
            inputRef={ref}
            focused={fieldDateNumber === 1}
            value={props.value.od || null}
            format='yyyy-MM-dd'
            views={['year', 'month', 'day']}
            sx={{maxWidth: 120}}
            onChange={handleChangeOd}              
            onFocus={handleFocusOd}
          />        
        </Stack>
        <Typography>-</Typography>
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
          <DateField
            focused={fieldDateNumber === 2}
            value={props.value.do || null}
            format='yyyy-MM-dd'
            views={['year', 'month', 'day']}
            sx={{maxWidth: 120}}
            onChange={handleChangeDo}
            onFocus={handleFocusDo}
          />
        </Stack>
        <FormLabel 
          sx={{
            fontSize: 16, 
            fontWeight: 400, 
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            transformOrigin: 'top left',
            transform: 'translate(0, -1.5px) scale(0.75)',
          }}
        >
          {props.label}
        </FormLabel>        
      </Stack>       
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} sx={{p: 2}}>
        <DateCalendar 
          value={getValue()}
          // maxDate={value.do || null}
          format="yyyy-MM-dd"
          views={['year', 'month', 'day']}
          onChange={handleChangeCalendar}
          slots={{ day: InRangeDay }}
          slotProps={{
            day: (ownerState) => ({
              fieldnumber: fieldDateNumber,
              valueRange: props.value,
              hoveredday: hoveredDay,
              onPointerEnter: () => setHoveredDay(ownerState.day),
              // onPointerLeave: () => setHoveredDay(null),
            }),
          }}          
        />        
      </Stack>
      <Stack direction="row" justifyContent='space-between' alignItems="center" spacing={1} sx={{p: 1}}>
        <Stack direction="row" justifyContent='flex-end' alignItems="center" spacing={1} sx={{p: 1}}>
          <Button onClick={handleClear}>{xxXX.components.MuiLocalizationProvider.defaultProps.localeText.clearButtonLabel}</Button>
          <Button onClick={handleChangeNaw}>{xxXX.components.MuiLocalizationProvider.defaultProps.localeText.todayButtonLabel}</Button>
        </Stack>
        <Button onClick={handleClose}>{'Ok'}</Button>
      </Stack>            
    </LocalizationProvider>              
  )
}

export default class Bs4DateRange  extends Bs4GenericField {

  atrybOnchange = Bs4GenericField.CHANGE_SELF;

  text_From = Bs4I18N.getTT('From:', 'Od:', 'Bs4DateRange');
  text_To   = Bs4I18N.getTT('To:', 'Do:', 'Bs4DateRange');

  // setValueBs4(value) {
  //   console.log('...Bs4DateRange ..setValueBs4...', value)
  //   let newValue = value;
  //   // if (!newValue) newValue = {od: '', do: ''};
  //   // if (newValue.od instanceof Date && !isNaNnull(newValue.od)) newValue.od = Bs4Utils.toDate(newValue.od);
  //   // if (newValue.do instanceof Date && !isNaNnull(newValue.do)) newValue.do = Bs4Utils.toDate(newValue.do);    
  //   super.setValue(newValue);
  // }

  setValueBs4(value) {    
    if (!Bs4Utils.isObject(value)) value = {};
    value.od = Bs4Utils.getValidDate(value.od);
    value.do = Bs4Utils.getValidDate(value.do);
    this.setValue(value);
  }

  isEmpty () {
    const value = this.getValue();
    if (!Bs4Utils.isObject(value)) return true;
    if (!value.od && !value.do) return true;
    return false;
  }

  getValueBs4() {    
    const value = {...(this.getValue() || {})};
    value.od = Bs4Utils.toDateTime(value.od);
    value.do = Bs4Utils.toDateTime(value.do);
    if (!value.od && !value.do) return '';    
    if (value.od === '' && value.do === '') return '';
    return value;
  }

  getValueBs4Short() {    
    const value = {...(this.getValue() || {})} ;
    value.od = Bs4Utils.toDate(value.od);
    value.do = Bs4Utils.toDate(value.do);
    if (!value.od && !value.do) return '';    
    if (value.od === '' && value.do === '') return '';
    return value;
  }

  getShortValue(full) {    
    const value = this.getValueBs4Short();    
    return this.text_From+(value?.od || '')+', '+this.text_To+(value?.do || '');
  }

  getDataRangeText = (value) => {
    try {
      if (Bs4Utils.toDate(value.od) == Bs4Utils.toDate(value.do)) {
        return format(value.od, 'yyyy-MM-dd');        
      } else {
        return format(value.od, 'yyyy-MM-dd') + '  -  ' + format(value.do, 'yyyy-MM-dd');
      }
    } catch(error) {
      return '';
    }
  }

  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue() || '');
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const ref = React.useRef(null);
    this.refFocus = React.useRef();
    
    const openField = React.useCallback((target) => {      
      if (formField.readOnly) {
        setAnchorEl(null);
        return;
      }
      setAnchorEl(ref.current);
    }, [setAnchorEl]);

    const closeField = React.useCallback(() => {
      setAnchorEl(null);
    }, [setAnchorEl]);
    
    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue() || '');
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })    
    }, [error]);

    React.useEffect(() => {
      const closeForm = () => {closeField()};
      this.bs4Form.eventEmit.on(Bs4GenericField.CLOSE_BS4_FORM, closeForm);
      return () => this.bs4Form.eventEmit.off(closeForm);
    }, [closeField])

    const handleChange = (value) => {
      this.setValue(value);    
    }

    const handleFocus = (event) => {
      event?.stopPropagation();
      if (!props.canOpenDialog) openField(event.target)
      event.target.blur();
    }

    const handleOpen = (event) => {
      this.trigger(Bs4GenericField.FOCUS_ENTER, this);
    }

    const handleClose = (event) => {
      this.trigger(Bs4GenericField.FOCUS_LEAVE, this);
      this.trigger(Bs4GenericField.CHANGE_SELF, this);

      event?.stopPropagation();
      closeField();      
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') handleClose(event);
    }

    const handleClickAdornment = (event) => {
      openField(this.refFocus.current);
    }

    return (
      <React.Fragment>
        <TextField
          ref={ref}
          inputRef={formField.refFocus}    
          focused={false}
          fullWidth={props.fullWidth}
          label={<formField.Bs4Label/>}
          value={formField.getDataRangeText(value)}
          error={error.error}
          helperText={error.helperText}
          autoComplete='off'          
          slotProps={{
            inputLabel: formField.props.field.hideLabel ? {sx:{display:'none'}} : null,
            htmlInput: {readOnly: formField.readOnly},
            input: {
              disableUnderline: formField.readOnly,
              endAdornment:(
                <InputAdornment position="end">
                  <IconButton disabled={Boolean(formField.readOnly)} edge='end' onClick={handleClickAdornment}>
                    <i className="fa-regular fa-calendar-range"></i>
                  </IconButton>
                </InputAdornment>
              )
            },
          }}
          onFocus={handleFocus}          
        />       
        <Bs4PopoverModal 
          anchorEl={anchorEl} 
          open={Boolean(anchorEl)} 
          onOpen={handleOpen} 
          onClose={handleClose} 
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
            vertical: 0, 
            horizontal: 8,
          }}
          onKeyDown={handleKeyDown}
        >
          <Bs4DateRangePicker 
            value={value} 
            onChange={handleChange} 
            onClose={handleClose} 
            label={<formField.Bs4Label/>}
          />
        </Bs4PopoverModal>
      </React.Fragment>
    )
  }
}